var map = {
	"./1.svg": 831,
	"./2.svg": 832,
	"./3.svg": 833,
	"./4.svg": 834,
	"./5.svg": 835,
	"./6.svg": 836,
	"./7.svg": 837,
	"./8.svg": 838,
	"./9.svg": 839
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 830;